/** Traductions modal import Excel produits (FR / AR) — guided review + catalogue */
export const excelImportModalFr = {
  title: 'Importation Excel',
  selectFile: 'Sélectionner un fichier Excel',
  dropHint: 'Glissez-déposez un fichier Excel ici ou cliquez pour sélectionner',
  chooseFile: 'Choisir fichier',
  downloadTemplate: 'Télécharger le modèle Excel',
  pipelineHint:
    'Comme Ajouter Produit : catégorie auto, SKU suivant le dernier PROD###, conservation et code-barres. Confirmez chaque produit, puis l’achat s’ouvre pour le stock (la facture reste comme d’habitude).',
  languageDetected: 'Langue détectée : {{language}} — {{fields}} colonnes reconnues',
  languageBadge: 'En-têtes détectés : {{language}}',
  missingNameColumn: 'Colonne « Nom du produit » / « اسم المنتج » introuvable',
  lang: {
    ar: 'Arabe',
    fr: 'Français',
    mixed: 'Mixte (FR/AR)',
    unknown: 'Inconnue'
  },
  previewTitle: 'Aperçu des données',
  moreRows: 'Et {{count}} autres lignes...',
  cancel: 'Annuler',
  importingShort: 'Importation...',
  importProducts: 'Importer les produits',
  startReview: 'Vérifier produit par produit',
  invalidFile: 'Veuillez sélectionner un fichier Excel valide (.xlsx ou .xls)',
  readError: 'Erreur lors de la lecture du fichier Excel',
  importError: 'Erreur lors de l\'importation',
  rowNameRequired: 'Nom du produit requis',
  importResult:
    '{{success}} ligne(s) traitée(s) ({{newCount}} nouveau(x), {{updatedCount}} mis à jour){{errorsPart}}',
  importErrorsPart: ', {{count}} erreurs',
  saveOrderLabel: 'Chemin d\'enregistrement',
  saveStepKv: '1. Enregistrement catalogue produits',
  saveStepCache: '2. Rafraîchissement cache lecture',
  reviewTitle: 'Confirmer le produit',
  reviewProgress: 'Produit {{current}} / {{total}}',
  reviewName: 'Nom',
  reviewSku: 'SKU',
  reviewSkuHint: 'Suit le dernier PROD### du catalogue (comme l’ajout manuel)',
  reviewCategory: 'Catégorie',
  reviewCategoryAuto: 'Auto · {{category}}',
  reviewCategoryAutoHint: 'Déduite du nom ou de l’inventaire',
  reviewCategoryPlaceholder: 'Choisir une catégorie',
  reviewBarcode: 'Code-barres',
  reviewBarcodeHint: 'Scanner ou saisir',
  reviewConservation: 'Conservation',
  reviewConservationAuto: 'Suggestion intelligente selon le type de produit',
  reviewUnit: 'Unité',
  reviewConfirm: 'Confirmer',
  reviewConfirmUpdate: 'Mettre à jour',
  reviewConfirmAll: 'Confirmer tout le reste',
  reviewSkip: 'Passer',
  reviewNewBadge: 'Nouveau',
  reviewUpdateBadge: 'Mise à jour',
  enterNextHint: 'Entrée → champ suivant · Entrée sur le dernier champ → confirmer',
  noExpiry: 'Sans date',
  longConservation: 'Longue',
  mediumConservation: 'Moyenne',
  perishable: 'Périssable'
};

export const excelImportModalAr = {
  title: 'استيراد من Excel',
  selectFile: 'اختر ملف Excel',
  dropHint: 'اسحب وأفلت ملف Excel هنا أو انقر للاختيار',
  chooseFile: 'اختيار ملف',
  downloadTemplate: 'تحميل قالب Excel',
  pipelineHint:
    'مثل إضافة منتج: فئة تلقائية، SKU يتبع آخر PROD###، الحفظ والباركود. أكّد كل منتج ثم يُفتح الشراء للمخزون (الفاتورة كما هي).',
  languageDetected: 'اللغة المكتشفة: {{language}} — تم التعرف على {{fields}} عمود',
  languageBadge: 'العناوين المكتشفة: {{language}}',
  missingNameColumn: 'عمود « اسم المنتج » / « Nom du produit » غير موجود',
  lang: {
    ar: 'العربية',
    fr: 'الفرنسية',
    mixed: 'مختلط (عربي/فرنسي)',
    unknown: 'غير معروفة'
  },
  previewTitle: 'معاينة البيانات',
  moreRows: 'و {{count}} صفوف أخرى...',
  cancel: 'إلغاء',
  importingShort: 'جاري الاستيراد...',
  importProducts: 'استيراد المنتجات',
  startReview: 'مراجعة منتجًا بمنتج',
  invalidFile: 'يرجى اختيار ملف Excel صحيح (.xlsx أو .xls)',
  readError: 'خطأ في قراءة ملف Excel',
  importError: 'خطأ في الاستيراد',
  rowNameRequired: 'اسم المنتج مطلوب',
  importResult:
    'تمت معالجة {{success}} صف ({{newCount}} جديد، {{updatedCount}} محدث){{errorsPart}}',
  importErrorsPart: '، {{count}} أخطاء',
  saveOrderLabel: 'مسار الحفظ',
  saveStepKv: '1. حفظ كتالوج المنتجات',
  saveStepCache: '2. تحديث كاش القراءة',
  reviewTitle: 'تأكيد المنتج',
  reviewProgress: 'منتج {{current}} / {{total}}',
  reviewName: 'الاسم',
  reviewSku: 'SKU',
  reviewSkuHint: 'يتبع آخر PROD### في الكتالوج (مثل الإضافة اليدوية)',
  reviewCategory: 'الفئة',
  reviewCategoryAuto: 'تلقائي · {{category}}',
  reviewCategoryAutoHint: 'مستنتج من الاسم أو المخزون',
  reviewCategoryPlaceholder: 'اختر فئة',
  reviewBarcode: 'الباركود',
  reviewBarcodeHint: 'امسح أو أدخل',
  reviewConservation: 'الحفظ',
  reviewConservationAuto: 'اقتراح ذكي حسب نوع المنتج',
  reviewUnit: 'الوحدة',
  reviewConfirm: 'تأكيد',
  reviewConfirmUpdate: 'تحديث',
  reviewConfirmAll: 'تأكيد الباقي',
  reviewSkip: 'تخطّي',
  reviewNewBadge: 'جديد',
  reviewUpdateBadge: 'تحديث',
  enterNextHint: 'Enter → الحقل التالي · Enter في آخر حقل → تأكيد',
  noExpiry: 'بدون تاريخ',
  longConservation: 'طويل',
  mediumConservation: 'متوسط',
  perishable: 'قابل للتلف'
};
